/** The registration type of an activity; Approval is coded P and Registration R. */
export enum ClsfActivityRegistrationType {
	None = 0,
	Approval = 1,
	Registration = 2,
}

/** The registration types an activity can be given; `None` is the absence of one. */
export const SELECTABLE_CLSF_ACTIVITY_REGISTRATION_TYPES: readonly ClsfActivityRegistrationType[] = [
	ClsfActivityRegistrationType.Approval,
	ClsfActivityRegistrationType.Registration,
];
